<template>
  <div class="col-12">
    <div class="card card-height" :class="$attrs.class">
      <div class="p-3 pb-0 card-header">
        <div class="d-flex justify-content-between">
          <h5 class="mb-2">{{ $t('key_entities_not_registered') }}</h5>
        </div>
      </div>
      <div class="table-responsive">
        <full-table
          v-if="!!rows"
          :items="rows"
          :headers="headers"
          :enable-search="false"
          :enable-pagination="false"
        >
          <template #row="entity">
            <td class="font-weight-bold">
              <a class="cursor-pointer text-xs picko-link mb-0" :title="$t('key_view_entities')"
                @click="goDetail(entity)">
              <span v-if="entity.title == 'ARTÍCULOS'">{{ $t('key_products') }}</span>
              <span v-if="entity.title == 'PEDIDOS'">{{ $t('key_orders') }}</span>
              <span v-if="entity.title == 'DEVOLUCIONES'">{{ $t('key_returns') }}</span>
              <span v-if="entity.title == 'ENTRADAS PROVEEDOR'">{{ $t('key_purchases') }}</span>
              </a>
            </td>
            <td class="font-weight-bold" :class="[entity.amount > 0 ? 'text-danger' : '']">
              <span class="my-2 text-xs">{{ entity.amount }}</span>
            </td>
          </template>

        </full-table>
      </div>
    </div>
  </div>
</template>

<script>

  import { FullTable } from "@/hotaka/components";

  export default {
    name: "PendingProductStock",
    components: {
      FullTable,
      // Globe,
    },
    data() {
      return {
        rows: [],
        headers:[
          
        ],
      };
    },
    computed: {
      entities() {
        return this.$store.state.dashboard.entitiesNotRegistered.data;
      },
    },
    watch: {
      entities() {
        this.rows.push(
          {
            title: 'ARTÍCULOS',
            amount: this.entities['products'],
            type: 'product'
          },
          {
            title: 'PEDIDOS',
            amount: this.entities['orders'],
            type: 'order'
          },
          {
            title: 'DEVOLUCIONES',
            amount: this.entities['orders_back'],
            type: 'orderBack'
          },
          {
            title: 'ENTRADAS PROVEEDOR',
            amount: this.entities['purchases'],
            type: 'purchase'
          }
        )
      },
    },
    mounted() {
      this.getEntities()
    },
    methods: {
      goDetail(row){
        switch(row['type']) {
          case 'order':
            this.$router.push({ path: "/Operations/Orders", query: { status: 'NO_REGISTRADO' }});
            break;
          case 'orderBack':
            this.$router.push({ path: "/Operations/Ordersback", query: { status: 'NO_REGISTRADO' }});
            break;
          case 'purchase':
            this.$router.push({ path: "/Operations/Purchases", query: { status: 'NO_REGISTRADO' }});
            break;
          case 'product':
            this.$router.push({ path: "/MasterData/Products", query: { status: 'NO_REGISTRADO' }});
            break;
        }
      },
      getEntities(){
        this.$store.commit("dashboard/getEntitiesNotRegistered");
      },
    }
  };
  </script>
  <style scoped>

  .table-responsive {
    padding: 1rem;
    min-height: 20rem;
  }

  .table-container {
    height: 17rem;
    overflow-x: hidden;
  }
  table {
    display: flex;
    flex-flow: column;
    height: 100%;
    width: 100%;
  }
  table thead {
    flex: 0 0 auto;
    text-align: left;
    width: calc(100% - 0.9em);
  }
  table tbody {
    flex: 1 1 auto;
    display: block;
    overflow-y: scroll;
    min-width: 48rem !important;
  }
  table tbody tr {
    width: 100%;
  }
  table thead,
  table tbody tr {
    display: table;
    table-layout: fixed;
  }
  /* decorations */
  .table-container {
      padding: 0.3em;
  }
  table td, table th {
      padding: 0.3em;
  }

  .card-height {
    min-height: 23.7rem !important;
  }

</style>
